import React from 'react';
import { Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer 
      data-testid="footer"
      className="py-12 px-6 bg-[#080C10] border-t border-[#C9A84C]/10"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="text-center md:text-left">
            <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-[#C9A84C]">
              KILLING OVER WATER
            </h3>
          </div>

          {/* Credits */}
          <div className="text-center">
            <p className="font-['Outfit'] text-[#E8E0D0]/50 text-sm">
              Stories by Cupe James / 3amStudios / Taste Of New York Entertainment
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/killingoverwater"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#E8E0D0]/40 hover:text-[#C9A84C] transition-colors"
              aria-label="Instagram"
              data-testid="social-instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://www.threads.net/@killingoverwater"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#E8E0D0]/40 hover:text-[#C9A84C] transition-colors"
              aria-label="Threads"
              data-testid="social-threads"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.186 24h-.007C5.461 23.956.057 18.509 0 11.757v-.113C.057 5.19 5.461-.257 12.179-.3h.014c3.44.023 6.494 1.367 8.768 3.67a12.13 12.13 0 0 1 3.039 5.3l-2.007.463a10.14 10.14 0 0 0-2.54-4.432A10.05 10.05 0 0 0 12.193 1.7h-.014C6.572 1.736 2.057 6.293 2.007 11.96v.08c.05 5.667 4.565 10.224 10.172 10.26h.007c2.642-.02 5.063-1.042 6.886-2.886a10.14 10.14 0 0 0 2.84-5.67l2.007.345a12.14 12.14 0 0 0-3.396 6.782 12.05 12.05 0 0 1-8.337 3.129zM17.2 17.5c-1.33 1.33-3.17 2.1-5.07 2.1-3.88 0-7.04-3.16-7.04-7.04 0-3.88 3.16-7.04 7.04-7.04 3.88 0 7.04 3.16 7.04 7.04 0 1.9-.77 3.74-2.1 5.07l-.02-.02c-.27.27-.56.51-.87.73l-1.17-1.62c.22-.16.43-.34.62-.53.93-.93 1.46-2.21 1.46-3.53 0-2.77-2.27-5.04-5.04-5.04S7.09 9.79 7.09 12.56s2.27 5.04 5.04 5.04c1.04 0 2.04-.32 2.88-.91l1.17 1.62c-.3.21-.62.4-.95.57l-.03.02z"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@killingoverwater"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#E8E0D0]/40 hover:text-[#C9A84C] transition-colors"
              aria-label="TikTok"
              data-testid="social-tiktok"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
            <a
              href="https://x.com/klgovrwtr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#E8E0D0]/40 hover:text-[#C9A84C] transition-colors"
              aria-label="X (Twitter)"
              data-testid="social-twitter"
            >
              <Twitter size={20} />
            </a>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="mt-8 pt-6 border-t border-[#C9A84C]/5 text-center">
          <p className="font-['Outfit'] text-[#E8E0D0]/30 text-xs">
            Inspired by Matthew Franklin & Joseph Green. The water always remembers.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
